// extracted by mini-css-extract-plugin
export default {"container":"Contact_container__pmibH","title":"Contact_title__x8SZB","form":"Contact_form__fXePt"};